export default __webpack_public_path__ + "ec4a06c97bc6e310528c0e8919b2de2e.svg";